import React, { forwardRef } from "react"
import { slugify } from "@utils/slugify"
import type { AccordionProps } from "./types"
import {
    ChevronDown,
    StyledAccordion,
    StyledAccordionContent,
    StyledAccordionContentText,
    StyledAccordionHeaderRow,
    StyledAccordionItem,
    StyledAccordionTrigger,
    Title
} from "./styles"

const Accordion = forwardRef<HTMLDivElement, AccordionProps>(({
    css,
    items
}, ref) => {
    return <StyledAccordion
        ref={ref}
        type="single"
        collapsible
        css={css}
    >
        {items?.map((item, index) => (
            <StyledAccordionItem key={`item-${slugify(item.title)}`} value={`item-${index}`}>
                <StyledAccordionHeaderRow asChild>
                    <p>
                        <StyledAccordionTrigger>
                            <Title>{item.title}</Title>
                            <ChevronDown />
                        </StyledAccordionTrigger>
                    </p>
                </StyledAccordionHeaderRow>
                <StyledAccordionContent asChild>
                    <StyledAccordionContentText
                        dangerouslySetInnerHTML={{ __html: item.content }}
                    />
                </StyledAccordionContent>
            </StyledAccordionItem>
        ))}
    </StyledAccordion>
})

export default Accordion
